import { Component, OnInit, Inject } from '@angular/core';
import { ManageComponentsService } from '../manage-components.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FileReaderEvent } from '../../../shared/models/FileReader';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-component-details',
  templateUrl: './component-details.component.html',
  styleUrls: ['./component-details.component.scss']
})

export class ComponentDetailsComponent implements OnInit {


  public Title: string
  public ImageDataBase64: string
  public ToolId: number
  public ImageType: string
  public imgcompartid: number

  selectedFile: File;
  form: FormGroup;
  loading: boolean = false;
  ngOnInit(): void {
    this._componentservice.getMeasurementTools().subscribe(r => { this._componentservice.measurementToolsList = r; });
    if (this.data.ImageDataBase64)
      this.ImageDataBase64 = this.data.ImageDataBase64;
    this.ImageType = this.data.ImageType
    this.ToolId = this.data.ToolId
    this.Title = this.data.Title
  }

  ImageLoading: boolean = false
  constructor(private fb: FormBuilder,
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ComponentDetailsComponent>,
    public _componentservice: ManageComponentsService,
    private _notify: NotificationsService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: any,

  ) { }

  NoClick(): void {
    this.data = ''
    this.ImageDataBase64 = ""
    this.ImageType = ""
    this.ToolId = -1
    this.Title = ""
    this.dialogRef.close();

  }


  uploadPhoto(newPhoto: string) {

    this.ImageDataBase64 = newPhoto.split(",")[1];
    this.data.ImageDataBase64 = this.ImageDataBase64;
    let str = newPhoto.split(",")[0];
    let type = str.split(":");
    this.data.ImageType = type[1].split(";")[0];
  }


  onSelectPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string);
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

//   saveMeasurementImageDialog() {
//     this._componentservice.saveMeasurementImage(this.data.compartid_auto, this.Title, this.ImageDataBase64, this.ToolId, this.ImageType)
//       .subscribe(response => {
//         if (response) {
//           this._notify.success('Saved', 'Measurement Image save');

//         } else {
//           this._notify.error('Error', 'Unable to save the Measurement images. Please contact TrackTreads support.');


//         }

//         this.ImageDataBase64 = ""
//         this.ImageType = ""
//         this.ToolId = -1
//         this.Title = ""
//         this.dialogRef.close();
//       });
//   }

saveMeasurementImageDialog() {
  this._componentservice.saveMeasurementImage(
    this.data.compartid_auto, 
    this.Title, 
    this.ImageDataBase64, 
    this.ToolId, 
    this.ImageType
  ).subscribe(
    response => {
      console.log('Response:', response); // Debugging: Log the response

      if (response) {
        this._notify.success('Saved', 'Measurement Image saved successfully.');
      } else {
        this._notify.error('Error', 'Unable to save the Measurement images. Please contact support.');
      }

      // Resetting values
      this.ImageDataBase64 = "";
      this.ImageType = "";
      this.ToolId = -1;
      this.Title = "";

      this.dialogRef.close();
    },
    error => {
      console.error('Error:', error); // Debugging: Log the error
      this._notify.error('Error', 'An unexpected error occurred while saving the Measurement image.');
      this.dialogRef.close();
    }
  );
}


}


